export const EXP_API_URI = '/api/client/experience/v2/load/';
export const EXP_API_URI_V2 = '/apims/client/experience/v2/load';
export const RXLABEL = 'RXLABEL_LOOKUP';
export const RXLABEL_FLOW_NAME = 'rxlabel';
export const PHONE_DOB_FLOW_NAME = 'caregiving';
export const PROFILE_ID_TYPE = 'RETAIL_PROFILE_ID_TYPE';
export const RETAIL_PROFILE_ID_TYPE = 'RETAIL_PROFILE_ID_TYPE';
export const DEMO_LOOKUP_ID_TYPE = 'DEMO_LOOKUP_ID_TYPE';
export const DEMO_LOOKUP = 'DEMO_LOOKUP';
export const ENH_DEMO_LOOKUP = 'ENH_DEMO_LOOKUP';
export const DEMO_FLOW_NAME = 'caregiving';
export const PERSONAL_INFO = 'PH_DOB_LOOKUP';
export const ENH_PH_DOB_LOOKUP = 'ENH_PH_DOB_LOOKUP';
export const CAREGIVING_SOURCE_NAME = 'Caregiving';
export const ENTERPRISE_CAREGIVING_SOURCE_NAME = 'ENTERPRISE_CAREGIVING';
export const SELF_TIE_SOURCE_NAME = 'Pharmacy';
export const CAREGIVING_ACCESS_FLOW = 'caregiving_access';
export const ENTERPRISE_CAREGIVING_ACCESS_FLOW = 'ent_caregiving_access';
export const H4L_SOURCE_NAME = 'H4L';
export const APP_URL = '/account-lookup';
export const prodApiKey = process.env.NEXT_PUBLIC_I90_API_KEY_PROD;
export const nonProdApiKey = process.env.NEXT_PUBLIC_I90_API_KEY_NON_PROD;
export const clientId = 'access_enrichment';

export const XROUTEHDR = {
  gke: 'PHARMACY-GKE',
  rke: 'PHARMACY-RKE',
  gkeAndRke: 'account-gke-rke'
};

export const X_ROUTE_HEADER = 'x-route';

export const apiAttributes = [
  {
    envName: 'PROD',
    urlPrefix: 'https://www.cvs.com',
    apiHeader: undefined,
    expApikey: prodApiKey,
    introspect: {
      url: '/api/retail/token/v1/introspect',
      apikey: process.env.NEXT_PUBLIC_INTROSPECT_API_KEY_PROD
    }
  },
  {
    //specific to caremark
    envName: 'CTE1',
    urlPrefix: 'https://cte1www.caremark.com',
    apiHeader: undefined,
    expApikey: prodApiKey
  },
  {
    envName: 'QA1',
    urlPrefix: 'https://www-qa1.cvs.com',
    apiHeader: 'QA1',
    expApikey: nonProdApiKey,
    introspect: {
      url: '/api/retail/token/v1/introspect',
      apikey: process.env.NEXT_PUBLIC_INTROSPECT_API_KEY_NON_PROD
    }
  },
  {
    envName: 'QA2',
    urlPrefix: 'https://www-qa2.cvs.com',
    apiHeader: 'QA2',
    expApikey: nonProdApiKey,
    introspect: {
      url: '/api/retail/token/v1/introspect',
      apikey: process.env.NEXT_PUBLIC_INTROSPECT_API_KEY_NON_PROD
    }
  },
  {
    envName: 'PREVIEW',
    urlPrefix: 'https://www-qa2.cvs.com',
    apiHeader: 'QA2',
    expApikey: nonProdApiKey,
    introspect: {
      url: '/api/retail/token/v1/introspect',
      apikey: process.env.NEXT_PUBLIC_INTROSPECT_API_KEY_NON_PROD
    }
  },
  {
    envName: 'LOCAL',
    urlPrefix: 'https://www-qa2.cvs.com',
    apiHeader: 'QA2',
    expApikey: nonProdApiKey,
    introspect: {
      url: '/api/retail/token/v1/introspect',
      apikey: process.env.NEXT_PUBLIC_INTROSPECT_API_KEY_NON_PROD
    }
  }
];
